import React from "react"
import { NoteSections } from "./constants/Notes"
import { FileText, File } from "lucide-react"
import PropTypes from "prop-types";
import { handleErrorSentry } from "./constants/Error";

export function formatNoteName(string) {
    switch(string) {
        case ("physio"): {
            return "Physiotherapy Note"
        } case ("athletic"): {
            return "Athletic Note"
        } case ("chiropractic"): {
            return "Chiropractic Note"
        } case ("sports_medicine"): {
            return "Sports Medical Note"
        } case ("sports_medicine_consult_letter"): {
            return "Sports Medical Consult Letter"
        } case ("radiology"): {
            return "Radiology"
        } case ("therapy_cbt_dbt"): {
            return "Therapy - CBT / DBT Note"
        } case ("therapy_family_remediation"): {
            return "Therapy - Family Mediation Note"
        } case ("therapy_marriage_counselling"): {
            return "Therapy - Partner Counselling Note"
        } case ("therapy_parenting_plan"): {
            return "Therapy - Parenting Plan Note"
        } case ("emergency_response"): {
            return "Emergency Response"
        } case ("therapy_note"): {
            return "Therapy Note"
        } case ("therapy_case_note"): {
            return "Therapy - Case Note"
        } case ("therapy_intake_assessment_adult"): {
            return "Therapy - Intake Assessment Adult"
        } case ("therapy_intake_assessment_child"): {
            return "Therapy - Intake Assessment Child"
        } case ("referrel_letter_short"): {
            return "Referral Letter Short"
        } case ("cb_exit_form"): {
            return "CB - Exit Medical"
        } case ("np_soap"): {
            return "NP SOAP"
        } case ("dr_arthur_template"): {
            return "Dr. Arthur Template"
        } case ("dr_beth_template"): {
            return "Dr. Beth Template"
        } case ("npwt_order"): {
            return "NPWT Order"
        } case ("npwt_procedure_note"): {
            return "NPWT Procedure Note"
        } case ("mist_therapy_note"): {
            return "MIST Therapy Note"
        } case ("rof_azizi"): {
            return "ROF - Dr. Azizi"
        } case ("ptp_ml_azizi"): {
            return "PTP ML - Dr. Azizi"
        } case ("cash_fp_azizi"): {
            return "Cash FP - Dr. Azizi"
        } case ("cash_new_azizi"): {
            return "Cash New - Dr. Azizi"
        } case ("soap_therapy_azizi"): {
            return "Soap Therapy - Dr. Azizi"
        } case ("ptp_initial_consult_azizi"): {
            return "PTP Initial Consult - Dr. Azizi"
        } case ("ptp_progress_note_azizi"): {
            return "PTP Progress Note - Dr. Azizi"
        } case ("meg_kilvert_followup"): {
            return "Meg Kilvert Follow Up"
        } case ("grc_general_consult"): {
            return "GRC - General Consult"
        } case ("grc_pain_management"): {
            return "GRC - Pain Management"
        } case ("therapy_case_notes"): {
            return "Therapy Case Note"
        } case ("radiology_ct_ap_note"): {
            return "Radiology CT AP Note"
        } case ("medlandmedical_acupuncture_note"): {
            return "MedlandMedical - Acupuncture Note"
        } case ("medlandmedical_pt_note"): {
            return "MedlandMedical - PT Note"
        } case ("dko_lof"): {
            return "DKOS - Lab Order Form"
        } case ("lab_invoice"): {
            return "DKOS - Lab Invoice"
        } case ("extended_health_care_info_sheet"): {
            return "DKOS - Extended Health Care IS"
        } case ("dkos_gait_assessment"): {
            return "DKOS - Biomechanical and Gait Assessment"
        } case ("oncology_initial_consult"): {
            return "Oncology - PC Initial Consult"
        } case ("dr_jp_cb_clearance_note"): {
            return "Dr. JP - CB Clearance Note"
        } case ("medlandmedical_pt_cpt_note"): {
            return "MedlandMedical - PT Note (CPT)"
        } case ("medlandmedical_pt_icd_note"): {
            return "MedlandMedical - PT Note (ICD)"
        } case ("canvas_compatible_wound_care_advanced_note"): {
            return "Canvas Compatible - Wound Care Advanced Note"
        } case ("cmcc_lower_back_physical_exam"): {
            return "CMCC - Lower Back Physical Exam"
        } case ("cmcc_ankle_exam"): {
            return "CMCC - Ankle Exam"
        } case ("cmcc_cervical_exam"): {
            return "CMCC - Cervical Exam"
        } case ("cmcc_elbow_exam"): {
            return "CMCC - Elbow Exam"
        } case ("cmcc_hip_exam"): {
            return "CMCC - Hip Exam"
        } case ("cmcc_knee_goals"): {
            return "CMCC - Knee Goals"
        } case ("cmcc_shoulder_exam"): {
            return "CMCC - Shoulder Exam"
        } case ("cmcc_thoracic_exam"): {
            return "CMCC - Thoracic Exam"
        } case ("cmcc_wrist_hand_finger_exam"): {
            return "CMCC - Wrist Hand Finger Exam"
        } case ("cmpt_mass_daily_note"): {
            return "CMPT Mass - Daily Note"
        } case ("cmpt_mass_eval_note"): {
            return "CMPT Mass - Eval Note"
        }
        default: {
            return capitalizeWords(string, "_");
        }
    }
}

export function formatNoteSections(string) {
    switch(string) {
        case ("general_notes"): {
            return "General Notes / Family Medicine"
        }
        default: {
            return capitalizeWords(string, "_");
        }
    }
}


export function capitalizeWords(sentence, factor) {
    const words = sentence.split(factor);
    const capitalizedWords = words.map(word => {
      return word.charAt(0).toUpperCase() + word.slice(1);
    });
    return capitalizedWords.join(' ');
}

export function checkExistingTitles(string) {
    const regex = /\*\*([^*]+)\*\*/g;
    return regex.test(string);
}


export function formatPhoneNumber(phoneString) {
    if (!phoneString) {
        return phoneString;
    }

    let input = phoneString.replace(/\D/g, "");
    let proper_number = "";

    if (input.length >= 10) {
        proper_number += `(${input.substring(0 , 3)})-${input.substring(3 , 6)}-${input.substring(6, 10)}`;
    } else {
        proper_number = input;
    }
    return proper_number
}

export function grabAvatar(full_name) {
    if (full_name.includes(" ")) {
        const split_name = full_name.split(" ");
        return split_name[0].substring(0, 1).toUpperCase() + split_name[1].substring(0, 1).toUpperCase();
    } else {
        return full_name.substring(0, 1).toUpperCase();
    }
}

export function createNoteText(titles, noteBodyReferences) {
    try {
        let noteText = '';
        titles.forEach((title, index) => {
            index === 0 ? noteText += `**${title}**\n` : noteText += `\n\n**${title}**\n `;
            noteText += noteBodyReferences[index]?.current?.value ?? '';
        })
        return noteText;
    } catch (error) {
        handleErrorSentry(error, "tryCatch");
    }
}

export const chooseText = (note) => {
    try {
        if (!note.user_edited_result.value || note.user_edited_result.value.length <= 0) {
            return note.generated_result.value;
        } else {
            return note.user_edited_result.value;
        }
    } catch (error) {
        handleErrorSentry(error, "tryCatch");
    }
};


export function NoteNameIcon({ note_type, size = "15px" }) {
    return NoteSections.using_note_type(note_type) === "pdf_forms" ?  <File style={{ color: `var(--${NoteSections.using_note_type(note_type)})`, width: size }} />: <FileText style={{ color: `var(--${NoteSections.using_note_type(note_type)})`, width: size }}/>
}

NoteNameIcon.propTypes = {
    note_type: PropTypes.string.isRequired,
    size: PropTypes.string,
}